import React, { useContext, useState } from 'react'
import { useParams } from 'react-router'
import moment from 'moment'
import { Grid } from 'react-flexbox-grid'

import { getIntervalDates } from 'helpers/utils'
import { DashboardContext } from 'components/DashboardContext'
import { useQuery } from 'components/graphql'

import { LineChart, SalesLineChart, BarChart, SalesBarChart } from './components/Charts'
import { StyledDetailsContainer } from './components/styled'
import getCustomerFrequencies from './gql/getCustomerFrequencies'
import HeaderWithStats from 'components/HeaderWithStats'

export const dateFormat = 'YYYY-MM-DD'


const BranchDetails = () => {
	const { id: shopId } = useParams()
	const {
		activeDate, mainCurrency,
		geoData = [], branchList
	} = useContext(DashboardContext)
	const formatedDate = moment(activeDate).format(dateFormat)
	const branch = branchList?.find(shop => shop.id === shopId)

	const allowedCashRegisters = branch?.cashRegisters
		?.filter(cashRegister => cashRegister.isAvailableInWebApp)

	const allowedCrsIds = allowedCashRegisters
		?.map(cashRegister => cashRegister.id)

	const dateInterval = getIntervalDates(formatedDate)
	const [compareDate, setCompareDate] = useState({ choosenDay: formatedDate, choosenLabel: 'Today' })

	const bcResponse = useQuery(getCustomerFrequencies, {
		skip: !allowedCrsIds,
		variables: {
			periodStart: dateInterval.dateFrom,
			// periodEnd is exclusive in the backend, so query one day past the
			// week's Sunday to include it; dateInterval.dateTo stays Sunday for display
			periodEnd: moment(dateInterval.dateTo, dateFormat).add(1, 'days').format(dateFormat),
			cashRegisterIds: allowedCrsIds,
			timeCheck: true,
			interval: 15
		}
	})
	const bsResponse = useQuery(getCustomerFrequencies, {
		skip: !allowedCrsIds,
		variables: {
			periodStart: compareDate.choosenDay,
			periodEnd: moment(compareDate.choosenDay, dateFormat).add(1, 'days').format(dateFormat),
			cashRegisterIds: allowedCrsIds,
			timeCheck: true,
			interval: 15
		}
	})

	const { dateFrom, dateTo } = dateInterval
	const formatedDateFrom = moment(dateFrom).format('DD.MM.YYYY')
	const formatedDateTo = moment(dateTo).format('DD.MM.YYYY')

	return (
		<StyledDetailsContainer>
			<HeaderWithStats
				title={branch.name}
				geoData={geoData}
				shopId={shopId}
				type='branchDetails'
			/>
			<Grid className='defaultGrid'>
				<LineChart
					bcResponse={bcResponse}
					bsResponse={bsResponse}
					dateInterval={dateInterval}
					formatedDate={formatedDate}
					activeDate={activeDate}
					setCompareDate={setCompareDate}
					compareDate={compareDate}
				/>
				<SalesLineChart
					bcResponse={bcResponse}
					bsResponse={bsResponse}
					compareDate={compareDate}
					formatedDate={formatedDate}
					mainCurrency={mainCurrency}
				/>
				<BarChart
					bcResponse={bcResponse}
					bsResponse={bsResponse}
					formatedDateTo={formatedDateTo}
					formatedDateFrom={formatedDateFrom}
				/>
				<SalesBarChart
					bcResponse={bcResponse}
					bsResponse={bsResponse}
					formatedDateTo={formatedDateTo}
					formatedDateFrom={formatedDateFrom}
					mainCurrency={mainCurrency}
				/>
			</Grid>
		</StyledDetailsContainer>
	)
}

export default BranchDetails
